export enum AssetType {
  ORIGINAL_IMAGE = 'originalImage',
  ORIGINAL_ICON = 'originalIcon',
  SVG_IMAGE = 'svgImage',
  SVG_ICON = 'svgIcon',
  FONT = 'font',
  VIDEO = 'video',
  POWERPOINT = 'powerpoint',
}
